<template>
<div class="bg-gray-100 absolute w-full h-full flex justify-center items-center">
  <div class="w-full max-w-xs object-center">
      <header class="bg-white rounded-t px-8 py-4 pt-8">
          <img src="../assets/unither-logo-full.png" />
      </header>
      <form class="login bg-white shadow-md rounded-b px-8 pt-6 pb-8 mb-4">
          <div class="mb-4">
            <label for="id_username" class="block text-gray-700 text-sm font-bold mb-2">Username</label>
            <input 
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                v-model="username"
                type="text"
                placeholder="Username"
                autofocus="autofocus"
                maxlength="150"
                id="id_username" >
          </div>
          <div class="mb-4" >
            <label for="id_password" class="block text-gray-700 text-sm font-bold mb-2">Password</label>
            <input 
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                v-model="password"
                type="password"
                placeholder="Password"
                id="id_password" >
          </div>
          <div class="flex items-center justify-between mt-6">



                <button 
                    @click.prevent="authenticate"
                    class="bg-orange-500 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    type="submit">
                    Log In
                </button>
              <a href="https://unither.cpixapps.com/admin/password_change/" class="text-gray-500 hover:text-black" @click="onPasswordReset">Reset Password</a>


          </div>
          <div class="mt-6 text-center" v-if="errorMsg">
              <p class="text-orange-500 flex-grow pl-4">{{ errorMsg }}</p>
          </div>
          
           
      </form>
  </div>
  </div>
</template>

<script>

export default {

    mounted: function(){
        this.$store.dispatch('logout');
    },

    data: function(){
        return {
            username: '',
            password: '',
            errorMsg: ''
        }
    },

    methods: {
        authenticate: function(){
            this.$api.authenticate(this.username, this.password).then((authorized) => {
                if(authorized){
                    this.$store.commit('setAuthUser',{
                        authUser: this.$api.getUsername(),
                        isAuthenticated: true
                    })
                    this.$router.push("/").catch(err => {console.log(err)});
                }else{
                    this.password = '';
                    this.errorMsg = "Authorization Failed."
                }
            })
        },

        onPasswordReset: function(){
          //window.location.href = "https://unither.cpixapps.com/admin/password_change/";
            if(window.confirm("To change your password you will first be asked to login with your current or temporary password. Click OK to continue...")){
                console.log("changing to admin");
                window.location.href = "https://unither.cpixapps.com/admin/password_change/";
            }
        }
    }

}
</script>

<style>

</style>